/* eslint-disable no-undef */
import { erase, token } from '../../reducers/currentUser/currentUser.reducer';
import knownError from './knownError';
import { getFormData } from './formData';

export const patch = (url, body) => new Promise((resolve, reject) => {
  const formData = getFormData(body);
  const headers = {
    Accept: 'application/json',
    Authorization: token(),
  };

  const requestBody = formData || JSON.stringify(body);
  if (!formData) headers['Content-Type'] = 'application/json';

  return fetch(url, {
    method: 'PATCH',
    headers,
    body: requestBody,
  })
    .then((response) => {
      if (response.ok) return response.json().then(value => resolve(value));
      if (response.status === 400) return knownError(response, reject);
      if (response.status === 401) { document.location = '/login'; return erase(); }
      return reject();
    });
});



// WEBPACK FOOTER //
// ./src/helpers/api/patch.js